export function navigateToTasksSection() {
  Nav.to('/tasks');
}
